import { render, staticRenderFns } from "./PlayerThreat.vue?vue&type=template&id=f7c6670c&scoped=true"
import script from "./PlayerThreat.vue?vue&type=script&lang=js"
export * from "./PlayerThreat.vue?vue&type=script&lang=js"
import "./PlayerThreat.vue?vue&type=style&index=0&id=f7c6670c&prod&scoped=true&lang=css"
/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c6670c",
  null
  
)

export default component.exports